import { render } from "./StalledBets.vue?vue&type=template&id=6bc575ec&scoped=true&ts=true"
import script from "./StalledBets.vue?vue&type=script&lang=ts"
export * from "./StalledBets.vue?vue&type=script&lang=ts"

import "./StalledBets.vue?vue&type=style&index=0&id=6bc575ec&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bc575ec"]])

export default __exports__